import React from "react";

import { toast as sonnerToast } from "sonner";

import NotificationItem from "./NotificationItem";

/** I recommend abstracting the toast function
 *  so that you can call it without having to use toast.custom everytime. */
export default function notificationToast(toast) {
    return sonnerToast.custom((id) => <NotificationItem id={id} item={toast.item} handleNotificationClick={toast.handleNotificationClick} handleActionButtonClick={toast.handleActionButtonClick} dismissToast={() => sonnerToast.dismiss(id)} is_toast={true} />, {
        duration: 5000,
        position: "top-right",
        style: {
            top: "2rem",
        },
        closeButton: true,
    });
}
